module.exports = __webpack_public_path__ + "static/media/1.Crowd cheer.5a9481f3.mp3";